<script lang="ts">
  import type { Race } from '$types/races';

  export let runnerNumber: number;
  export let race: Race;

  $: results = race?.results;

  $: place = () => {
    if (!results) return 0;
    for (let i = 0; i < results.length; i++) {
      if ((results?.[i] ?? []).includes(runnerNumber)) return i + 1;
    }
    return 0;
  };
</script>

{#if place()}
  <span
    class="ml-3 inline-flex select-none items-center rounded px-2 py-0.5 text-xs font-medium shadow-sm placing-{place()}"
  >
    {place()}
  </span>
{/if}
